import { get, AHPLUS_API_URL } from "api/ky";

export const fetchFeatureFlags = async () => {
  return await get(`${AHPLUS_API_URL}/api/v2/feature_flags`);
};
